module.exports = __webpack_public_path__ + "img/teams.0248271c.png";